import "./ResetPassword.css";

import { useState } from "react";

import { auth } from "../../firebase";
import classnames from "classnames";
import { confirmPasswordReset } from "firebase/auth";
import logo from "../../assests/bunnyMoni.jpg";
import { useNavigate } from "react-router";
import zxcvbn from "zxcvbn";

const ResetPassword: React.FC = () => {
  const [password, setPassword] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const navigation = useNavigate();

  const oobCode = new URLSearchParams(window.location.search).get("oobCode");

  const handleReset = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!oobCode) {
      navigation("/error", {
        replace: true,
        state: { message: "auth token missing. try resetting again" },
      });
      return;
    }
    if (!password) {
      setMessage("Please enter your password.");
      return;
    }

    return confirmPasswordReset(auth, oobCode ?? "", password ?? "")
      .then(() => {
        navigation("/reset-success");
      })
      .catch((error) => {
        console.error("Password reset error:", error);
        navigation("/error", {
          replace: true,
          state: { message: error.message },
        });
      });
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setIsDisabled(zxcvbn(newPassword).score < 3);
  };

  return (
    <div className="container">
      <div className="card">
        <div className="logoContainer">
          <img className="logo" src={logo} alt="hobsavings logo" />
        </div>
        <h1 className="title">reset password</h1>
        <form onSubmit={handleReset}>
          <label htmlFor="password" className="label">
            enter new password:
          </label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={handlePasswordChange}
            className="input"
            placeholder="password"
            required
          />
          {message && <p className="message">{message}</p>}
          <div className="footer">
            <button
              type="submit"
              disabled={isDisabled}
              className={classnames("button", { buttonDisabled: isDisabled })}
            >
              reset password
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
